/* TempleTea — Product-card image click → navigate (ignore swipes & arrows) */
(function () {
  // flag so we can quickly verify in Console
  window.TT_CARD_CLICK_READY = 'loading';

  var startX = 0, startY = 0, dragged = false;

  function pt(e) {
    if (e && e.touches && e.touches[0]) return e.touches[0];
    if (e && e.changedTouches && e.changedTouches[0]) return e.changedTouches[0];
    return e;
  }
  function isModified(e) {
    return e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
  }
  function isControl(el) {
    return !!(el && el.closest('.tt-media-nav, .tt-dots'));
  }
  function getLink(target) {
    if (!target) return null;
    return target.closest('.tt-media-overlay-link, a.tt-media-slide[data-slide-link]');
  }

  // Track swipe vs click
  window.addEventListener('pointerdown', function (e) {
    var p = pt(e);
    startX = p.clientX; startY = p.clientY; dragged = false;
  }, true);

  window.addEventListener('pointermove', function (e) {
    var p = pt(e);
    if (Math.abs(p.clientX - startX) > 6 || Math.abs(p.clientY - startY) > 6) dragged = true;
  }, true);

  function handleClick(e) {
    if (isControl(e.target)) return;               // arrows/dots → ignore
    var link = getLink(e.target);
    if (!link) return;                             // not our image/overlay
    if (isModified(e)) return;                     // new-tab/middle click ok

    if (dragged) {                                 // swipe → no nav
      e.preventDefault();
      return;
    }

    // Own the click and navigate (some sliders cancel clicks)
    e.preventDefault();
    e.stopPropagation();
    setTimeout(function () { window.location.assign(link.href); }, 0);
  }

  // Run before most slider handlers
  window.addEventListener('click', handleClick, true);

  // Keyboard support for accessibility
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (isControl(e.target)) return;
    var link = getLink(e.target);
    if (!link) return;
    e.preventDefault();
    setTimeout(function () { window.location.assign(link.href); }, 0);
  }, true);

  window.TT_CARD_CLICK_READY = true;
})();
